import { useEffect, useState } from 'react';

const getRemainingSecondsFromNow = (endTime: number, interval: number) => Math.ceil((endTime - Date.now()) / interval);

// FIXME: needs a correct test with fake timers, we know JS timeouts and intervals work
// if the machine running tests is overloaded this will fail
// instead setInterval and setTimeout should be injected through arguments to use fake implementation in tests
// istanbul ignore next
export const useCountdown = (onTimerComplete: () => void, endTime: number, interval = 1000) => {
  const [count, setCount] = useState(getRemainingSecondsFromNow(endTime, interval));
  useEffect(() => {
    const finalize = () => {
      onTimerComplete();
      setCount(0);
      clearInterval(updateId);
    };

    const update = () => {
      setCount(getRemainingSecondsFromNow(endTime, interval));
    };

    update();

    const finalizeId = setTimeout(finalize, endTime - Date.now());
    const updateId = setInterval(update, interval);

    return () => {
      clearTimeout(finalizeId);
      clearInterval(updateId);
    };
  }, [endTime, onTimerComplete, interval]);
  return count;
};
